
import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import {
  Col, Alert, Container, Row, Label, InputGroup, FormGroup,
} from "reactstrap"
import { AvField, AvForm, AvGroup } from "availity-reactstrap-validation"

import { connect } from "react-redux"
import PropTypes from "prop-types"
import { countries } from "../../common/data/country"
import { birthType, gender, bloodGroup, medium, classsection, studentclass } from "../../common/data/reportconstant"

import { isEmpty, isEqual } from "lodash"
import PageLoader from "pages/Common/PageLoader";
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import AsyncSelect from "react-select/async"
import { getPlacesAPIToken } from "store/actions"
import { getPlaces } from "helpers/backend_helper"
import { onGetCaptcha, groupReport, groupFetchReport } from "store/actions"
// import images
import logodark from "../../assets/images/kattam-login.png"


class GroupReport extends Component {

  constructor(props) {
    super(props)

    this.state = {
      firstName: '--',
      lastName: '--',
      gender: '',
      dateOfBirth: '',
      timeOfBirth: '',
      birthCountry: '',
      selectedPlaceofBirth:'',
      placeOfBirth: '',
      birthType: '',
      bloodGroup: '--',
      iqLevel: '',
      refferedBy: '--',
      aadharNumber: '111111111111',
      passportNumber: '',
      address1: '#275, Mission Street',
      address2: 'Opp.Cathedral Church',
      city: 'Puducherry',
      state: 'Pondicherry',
      zipCode: '605001',
      country: 'India',
      countryCode: '+91',
      mobile: '4132335541',
      email: 'immaculate_pdy@yahoo.com',
      date: new Date(),
      time: '00:00 AM',
      groupToken: '',
      placeId: '',
      meridies: 'Am',
      offsetInMunites: '',
      birthCountryName: '',
      placesToken: '',
      captchaToken: '',
      captchaOject: {},
      userCaptcha: '',
      loading: false,
      studentId: '',
      studentClass: '',
      section: '',
      medium: '',
      motherTongue: '--',

    }

    // handleValidSubmit
    this.handleValidSubmit = this.handleValidSubmit.bind(this)
    this.handleCountry = this.handleCountry.bind(this)
  }

  // handleValidSubmit
  handleValidSubmit(event, values) {
    event.preventDefault();
    const { placesToken, history } = this.props;
    this.state.captchaToken = this.state.captchaOject.captchaToken
    this.state.placeId = this.state.selectedPlaceofBirth.value
    this.state.placesToken = placesToken
    if (this.state.time === "00:00 AM") {
      this.state.timeOfBirth = "00:00:00 AM";
    } else {
      this.state.timeOfBirth = new Date(this.state.time).toTimeString();
    }
    this.state.firstName = this.state.studentId
    this.state.lastName = '(' + this.state.studentClass + ' ' + this.state.section + ')'
    this.state.dateOfBirth = new Date(this.state.date).toDateString();
    this.state.placeOfBirth = this.state.selectedPlaceofBirth.label;
    let groupReportData = this.state;
    this.props.groupReport(groupReportData, history)
  }

  handleCountry(event) {
    let country = JSON.parse(event.target.value);
    if (country == "-1") {
      this.setState({
        country: '',
        countryCode: ''
      })
      return;
    }
    this.setState({
      country: country.name,
      countryCode: country.pcode
    })
  }

  renderLoader = () => {
    if (this.state.loading === true)
      return <PageLoader loaderMsg="Processing your report... please wait..." />
    return null
  }

  renderError() {
    if (!isEmpty(this.props.groupReportError)) {
      if (isEqual(this.props.groupReportError, "Bad credentials")) {
        return <Alert color="danger">Invalid username or password</Alert>
      } else if (isEqual(this.props.groupReportError, "Invalid Captcha")) {
        return <Alert color="danger">Invalid captcha</Alert>
      } else {
        return <Alert color="danger">{this.props.groupReportError}</Alert>
      }
    } else
      return null;
  }

  componentDidMount() {

    const { match: { params }, } = this.props
    this.setState({
      groupToken: params.token,
    })
    const { placesAPIToken, onGetCaptcha, groupFetchReport } = this.props
    groupFetchReport(params.token);
    placesAPIToken();
    onGetCaptcha();
  }

  componentDidUpdate(prevProps, prevState) {
    const { captchaOject, placesToken, loading, registrationError } = this.props
    if (!isEmpty(captchaOject) && !isEqual(prevProps.captchaOject, captchaOject)) {
      this.setState({ captchaOject })
    }
    if (!isEqual(prevProps.loading, loading)) {
      this.setState({ loading: loading })
    }
  }



  loadSelectedPlace = async (placeInput, callback) => {
    const {  placesToken, } = this.props
    if (placeInput.length < 4)
      return;
    const response = await getPlaces(this.state.birthCountry, placeInput, placesToken)
    console.log(response)
    const json = await response
    console.log(json)
    callback(json.map(o => ({
      label: o.description,
      value: o.place_id + '|' + o.description,
      state: '',
      country: '',
      latitude: '',
      longitude: '',
      timeZone: ''
    })))
  }

  render() {
    const { registrationError, captchaOject, groupMaster } = this.props
    const imageSrc = "data:image/png;base64," + captchaOject.captchaImage;

    return (
      <React.Fragment>

        <div><Alert color='white'>

          <MetaTags>
            <title>AI Report | Kattam</title>
          </MetaTags>
          <Container fluid className="p-0">
            {this.renderLoader()}
            <table align = "center" >

            <Row className="g-0">

              <Col xl={12}>
                <div className="mb-4 mb-md-2">
                  <img
                    src={logodark}
                    alt=""
                    height="80"
                    className="auth-logo-dark" />
                </div>
              </Col>
            </Row>
            </table>
            <table align = "center" width="87%" border = "1">

            <Row className="g-0">
              <Col xl={12}>
                <div className="mb-4 mb-md-2">
                  <Alert color="primary" role="alert">
                   
                    <h4><center> {this.props.groupMaster.groupCountry}, {this.props.groupMaster.groupName} </center></h4>
                    <h4><center><span className="badge bg-primary">Institution Code:  {this.props.groupMaster.groupInstitutionCode}</span>{" "} </center></h4>
                    <h4 className="text-primary"><center>Artificial Intelligence Report</center></h4>
                  </Alert>


                </div>
              </Col>
            </Row>
           </table>
            <Row className="g-0">

              <Col xl={12}>
                <div className="auth-full-page-content p-md-4 p-2">
                  <div className="w-100">
                    <div className="d-flex flex-column h-100">

                      <AvForm
                        className="needs-validation"
                        onValidSubmit={this.handleValidSubmit}
                        autoComplete="off"
                      >
                        <table align = "center" width = "90%" border = "1">

                        <Alert color="info" className="mb-0" role="alert">
                          <h5 className="font-size-16 me-3">Student details</h5>
                        </Alert>
                        <Row>
                          <Col lg="6">
                            <Label>
                              Student Id <span style={{ color: 'red' }}>*</span>
                            </Label>
                            <AvField
                              name="studentId"
                              placeholder="ID"
                              type="text"
                              value={this.state.studentid}
                              onChange={(evt) => this.setState({ studentId: evt.target.value })}
                              errorMessage=" Please provide a student ID."
                              className="form-control"
                              validate={{ required: { value: true } }}
                              id="validationCustom05"
                            />
                          </Col>
                          <Col lg="6">
                            <div className="mb-3">
                              <Label>
                                Medium <span style={{ color: 'red' }}>*</span>
                              </Label>
                              <AvField type="select" name="medium" onChange={(evt) => this.setState({ medium: evt.target.value })}
                              >
                                <option disabled value="">Select Medium</option>
                                {medium.map(item => {
                                  return (<option key={item.value} value={item.value}>{item.text}</option>);
                                })}
                              </AvField>
                            </div>
                          </Col>
                        </Row>

                        <Row>
                          <Col lg="6">
                            <Label>
                              Class <span style={{ color: 'red' }}>*</span>
                            </Label>
                            <AvField type="select" name="class" onChange={(evt) => this.setState({ studentClass: evt.target.value })}
                              >
                                <option disabled value="">Select Class</option>
                                {studentclass.map(item => {
                                  return (<option key={item.value} value={item.value}>{item.text}</option>);
                                })}
                              </AvField>
                          </Col>
                          <Col lg="6">
                            <div className="mb-3">
                              <Label>
                                Section <span style={{ color: 'red' }}>*</span>
                              </Label>
                              <AvField type="select" name="section" onChange={(evt) => this.setState({ section: evt.target.value })}
                              >
                                <option disabled value="">Select Section</option>
                                {classsection.map(item => {
                                  return (<option key={item.value} value={item.value}>{item.text}</option>);
                                })}
                              </AvField>
                            </div>
                          </Col>
                        </Row>
                        <Alert color="info" className="mb-0" role="alert">
                          <h5 className="font-size-16 me-3">Birth details </h5> 
                        </Alert>

                        {/*<Row>
                          <Col lg="6">
                            <AvGroup className="mb-3">
                              <Label>
                                First name <span style={{ color: 'red' }}>*</span>
                              </Label>
                              <AvField
                                name="firstName"
                                placeholder="First name"
                                type="text"
                                errorMessage="Please enter a first name"
                                className="form-control"
                                validate={{ required: { value: true } }}
                                value={this.state.firstName}
                                onChange={(evt) => this.setState({ firstName: evt.target.value })}
                              />
                            </AvGroup>
                          </Col>
                          <Col lg="6">
                            <AvGroup className="mb-3">
                              <Label>
                                Last name
                              </Label>
                              <AvField
                                name="lastName"
                                className="form-control"
                                placeholder="Last name"
                                type="text"
                                value={this.state.lastName}
                                onChange={(evt) => this.setState({ lastName: evt.target.value })}
                                validate={{
                                  pattern: { value: '^(?!\d+$)(?:[a-zA-Z0-9][a-zA-Z0-9 ]*)?$', errorMessage: 'Last name can only contain aphanumeric and space' },
                                  maxLength: { value: 30, errorMessage: 'Last name must not be greater than 30 characters.' }
                                }}
                              />
                            </AvGroup>
                          </Col>
                              </Row> */}
                        <Row>
                          <Col lg="6">
                            <AvGroup className="mb-3 select2-container">
                              <Label>
                                Gender <span style={{ color: 'red' }}>*</span>
                              </Label>
                              <AvField type="select"
                                name="gender"
                                required
                                errorMessage="Please select a gender"
                                onChange={(evt) => this.setState({ gender: evt.target.value })}
                              >
                                <option disabled value="">Select gender</option>
                                {gender.map(item => {
                                  return (<option key={item.value} value={item.value}>{item.text}</option>);
                                })}

                              </AvField>
                            </AvGroup>
                          </Col>
                          <Col lg="6">
                            <div className="form-group mb-4">
                              <Label>
                                Birth Date <span style={{ color: 'red' }}>*</span>
                              </Label>
                              <div className="input-group">
                                <Flatpickr
                                  className="form-control d-block"
                                  placeholder="dd M,yyyy"
                                  options={{
                                    altInput: true,
                                    altFormat: "F j, Y",
                                    dateFormat: "Y-m-d",
                                    defaultDate: "today"
                                  }}
                                  onChange={date => {
                                    this.setState({ date });
                                  }}
                                />
                              </div>
                            </div>
                          </Col>
                        </Row>

                        <Row>
                          <Col lg="6">
                            <FormGroup className="mb-3">
                              <Label>
                                Birth Time <span style={{ color: 'red' }}>*</span>
                              </Label>

                              <InputGroup>
                                <Flatpickr
                                  className="form-control d-block"
                                  placeholder="HH:MM AM"
                                  options={{
                                    enableTime: true,
                                    noCalendar: true,
                                    dateFormat: "H:i",
                                    defaultDate: "00:00 AM",
                                    time_24hr: false,
                                    minuteIncrement: 1,
                                  }}
                                  onChange={time => {
                                    this.setState({ time });
                                  }}
                                />
                                <div className="input-group-append">
                                  <span className="input-group-text">
                                    <i className="mdi mdi-clock-outline" />
                                  </span>
                                </div>
                              </InputGroup>
                            </FormGroup>
                          </Col>
                          <Col lg="6">
                            <div className="mb-3">
                              <Label>
                                Birth country <span style={{ color: 'red' }}>*</span>
                              </Label>
                              <AvField type="select" name="birthCountry" onChange={(event) => {
                                let country = JSON.parse(event.target.value);
                                this.setState({
                                  birthCountry: country.code,
                                  birthCountryName: country.name
                                })
                              }}
                              >
                                <option disabled value="">Select birth country</option>
                                {countries.map((country, index) => (
                                  <option value={JSON.stringify(country)} key={index}>{country.name}</option>
                                ))}
                              </AvField>
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg="6">
                            <AvGroup className="mb-3">
                              <Label htmlFor="basicpill-place-input2">
                                Birth Place <span style={{ color: 'red' }}>*</span>
                              </Label>
                              <AsyncSelect
                                value={this.state.placeOfBirth}
                                onChange={(selectedPlace) => {
                                  this.setState({
                                    selectedPlaceofBirth: selectedPlace || [],
                                    placeOfBirth: selectedPlace || [],
                                  })
                                }}
                                placeholder={'Select place of birth'}
                                loadOptions={this.loadSelectedPlace}
                                classNamePrefix="select2-selection"
                                // className={this.state.passPlaceErrorField}
                                className="my-is-invalid"
                              />
                              {this.state.passPlaceErrorElement &&
                                <div className="my-invalid-feedback">Please select a birth place</div>
                              }
                            </AvGroup>
                          </Col>
                          <Col lg="6">
                            <AvGroup className="mb-3 select2-container">
                              <Label htmlFor="basicpill-place-input2">
                                Birth type <span style={{ color: 'red' }}>*</span>
                              </Label>
                              <AvField type="select"
                                name="birthType"
                                onChange={(evt) => this.setState({ birthType: evt.target.value })}
                                //label="Birth type"
                                // helpMessage="Idk, this is an example. Deal with it!"
                                required
                                errorMessage="Please select a birth type"
                              >
                                <option disabled value="">Select birth type</option>
                                {birthType.map(item => {
                                  return (<option key={item.value} value={item.value}>{item.text}</option>);
                                })}
                              </AvField>
                            </AvGroup>
                          </Col>
                        </Row>
                        {/*<Row>
                          <Col lg="6">
                            <Label htmlFor="basicpill-place-input2">
                              Blood Group <span style={{ color: 'red' }}>*</span>
                            </Label>
                            <AvGroup className="mb-3 select2-container">
                              <AvField type="select"
                                name="bloodGroup"
                                onChange={(evt) => this.setState({ bloodGroup: evt.target.value })}
                                //label="Blood Group"
                                // helpMessage="Idk, this is an example. Deal with it!"
                                required
                                errorMessage="Please select a blood group"
                              >
                                <option disabled value="">Select blood group</option>
                                {bloodGroup.map(item => {
                                  return (<option key={item.value} value={item.value}>{item.text}</option>);
                                })}
                              </AvField>
                            </AvGroup>
                          </Col>
                          <Col lg="6">
                          <AvGroup className="mb-3">
                              <Label>
                                Reffered by <span style={{ color: 'red' }}>*</span>
                              </Label>
                              <AvField
                                name="refferedBy"
                                placeholder="Reffered by"
                                type="text"
                                errorMessage="Please enter reffered by"
                                className="form-control"
                                required
                                helpMessage="Reffered by self / Doctor name"
                                value={this.state.refferedBy}
                                onChange={(evt) => this.setState({ refferedBy: evt.target.value })} />
                            </AvGroup>
                          </Col>
                              </Row>*/}
                        <Row>
                          <Col lg="6">
                            
                          </Col>
                          <Col lg="6">

                          </Col>
                        </Row>


                        <Alert color="info" className="mb-4" role="alert">
                          <h5 className="font-size-16 me-3">Personal details</h5>
                        </Alert>


                       {/* <Row>
                          <Col lg="6">
                            <AvGroup className="mb-3">
                              <Label>
                                Aadhar number
                              </Label>
                              <AvField
                                name="aadharNumber"
                                type="text"
                                placeholder="Aadhar Number"
                                maxLength="12"
                                value={this.state.aadharNumber}
                                onChange={(evt) => this.setState({ aadharNumber: evt.target.value })}
                                validate={{
                                  pattern: { value: '^[0-9]{12}$', errorMessage: 'Please enter a valid 12 digit aadhar number' }
                                }}
                              />
                            </AvGroup>
                          </Col>
                          <Col lg="6">
                            <AvGroup className="mb-3">
                              <Label>
                                Mother tongue
                              </Label>
                              <AvField
                                name="mothertongue"
                                type="text"
                                value={this.state.motherTongue}
                                onChange={(evt) => this.setState({ motherTongue: evt.target.value })}
                                placeholder="Mother Tongue"
                                maxLength="25"                            
                              />
                            </AvGroup>
                          </Col>
                        </Row>*/}
                        <Row>
                          <Col lg="12">
                            <Row>
                              <Label htmlFor="basicpill-countryCode">
                                Address <span style={{ color: 'red' }}>*</span>
                              </Label>
                              <Col>
                                <div className="mb-3">
                                  <AvField
                                    name="address1"
                                    type="text"
                                    readOnly="true"
                                    value={this.state.address1}
                                    onChange={(evt) => this.setState({ address1: evt.target.value })}
                                    placeholder="Address"
                                    validate={{
                                      required: { value: true, errorMessage: 'Please enter a address' },
                                      minLength: { value: 10, errorMessage: 'Address must have minimum 10 characters.' },
                                    }}
                                  />
                                </div>
                              </Col>
                              <Col>
                                <div className="mb-3">
                                  <AvField
                                    name="address2"
                                    readOnly="true"
                                    type="text"
                                    value={this.state.address2}
                                    onChange={(evt) => this.setState({ address2: evt.target.value })}
                                    placeholder="Address"
                                  />
                                </div>
                              </Col>
                            </Row>
                          </Col>

                        </Row>
                        <Row>
                          <Col lg="6">
                            <div className="mb-3">
                              <Label>
                                City <span style={{ color: 'red' }}>*</span>
                              </Label>
                              <AvField
                                name="city"
                                type="text"
                                readOnly="true"
                                value={this.state.city}
                                onChange={(evt) => this.setState({ city: evt.target.value })}
                                placeholder="City"
                                validate={{
                                  required: { value: true, errorMessage: 'Please enter a city' }
                                }}
                              />
                            </div>
                          </Col>
                          <Col lg="6">
                            <div className="mb-3">
                              <Label>
                                State <span style={{ color: 'red' }}>*</span>
                              </Label>
                              <AvField
                                name="state"
                                type="text"
                                readOnly="true"
                                value={this.state.state}
                                onChange={(evt) => this.setState({ state: evt.target.value })}
                                placeholder="State"
                                validate={{
                                  required: { value: true, errorMessage: 'Please enter a state' }
                                }}

                              />
                            </div>
                          </Col>
                        </Row>

                        <Row>
                          <Col lg="6">
                            <Label>
                              Zip <span style={{ color: 'red' }}>*</span>
                            </Label>
                            <AvField
                              name="zipCode"
                              placeholder="Zip Code"
                              type="text"
                              readOnly="true"
                              value={this.state.zipCode}
                              onChange={(evt) => this.setState({ zipCode: evt.target.value })}
                              errorMessage=" Please provide a valid zip code."
                              className="form-control"
                              validate={{ required: { value: true } }}
                              id="validationCustom05"
                            />
                          </Col>
                          <Col lg="6">
                            <div className="mb-3">
                              <Label>
                                Country <span style={{ color: 'red' }}>*</span>
                              </Label>
                              <AvField type="select" name="country" readOnly="true" onChange={this.handleCountry} value='{"name":"India","pcode":"+91","code":"IN"}'
                              >
                                <option disabled value="">Select country</option>
                                {countries.map((country, index) => (
                                  <option value={JSON.stringify(country)} key={index}>{country.name}</option>
                                ))}
                              </AvField>
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg="6">
                            <Row>
                              <Label htmlFor="basicpill-countryCode">
                                Mobile <span style={{ color: 'red' }}>*</span>
                              </Label>
                              <Col md="4" className="pe-md-0 md-pe-3">
                                <AvField type="text" name="countryCode" readOnly="true" placeholder="Code" value={this.state.countryCode}
                                  onChange={(evt) => this.setState({ countryCode: evt.target.value })}
                                  disabled
                                  validate={{
                                    required: { value: true, errorMessage: 'Please select a country code' }
                                  }}
                                >
                                </AvField>
                              </Col>
                              <Col md="" className="ps-md-0">
                                <AvField
                                  name="usermobile"
                                  type="text"
                                  readOnly="true"
                                  placeholder="User Mobile"
                                  value={this.state.mobile}
                                  onChange={(evt) => this.setState({ mobile: evt.target.value })}
                                  validate={{
                                    required: { value: true, errorMessage: 'Please enter mobile.' },
                                    pattern: { value: '^[0-9]{8,11}$', errorMessage: 'Please enter a valid mobile.' }
                                  }}
                                />
                              </Col>
                            </Row>
                          </Col>
                          <Col lg="6">
                            <div className="mb-3">
                              <Label>
                                Email <span style={{ color: 'red' }}>*</span>
                              </Label>
                              <AvField
                                name="email"
                                className="form-control"
                                placeholder="Email"
                                readOnly="true"
                                errorMessage="Please enter a vaild email"
                                type="email"
                                value={this.state.email}
                                onChange={(evt) => this.setState({ email: evt.target.value })}
                                required
                              />
                            </div>
                          </Col>
                        </Row>
                        


                        <Row className="d-flex align-items-center">
                          <Col md="4" className="pe-md-0 md-pe-3">
                            <div className="mb-3">
                              <Label>
                                Captcha <span style={{ color: 'red' }}>*</span>
                              </Label>

                              <AvField
                                name="userCaptcha"
                                type="text"
                                required
                                placeholder="Enter Captcha"
                                errorMessage="Please enter your Captcha"
                                value={this.state.userCaptcha}
                                onChange={(evt) => this.setState({ userCaptcha: evt.target.value })}
                              />

                            </div>
                          </Col>
                          <Col>
                            <div className="flex-grow-1">
                              <img id="ItemPreview" src={imageSrc} className="rounded-pill  w-md" />
                            </div>
                          </Col>
                        </Row>
                        </table>
                        <table align = "center">
                        <Row className="d-flex align-items-center">
                          <Col md="8" className="pe-md-0 md-pe-3">
                            <div className="float-end mt-2">
                              <button type="submit" className="btn btn-primary w-md">
                                Submit
                              </button>
                            </div>
                          </Col>
                        </Row>
                        </table>

                        {this.renderError()}
                      </AvForm>


                      <div className="mt-4 mt-md-5 text-center">
                        <p className="mb-0">
                        Copyright © {new Date().getFullYear()} Kattam Intelligence Pte. Ltd. All rights reserved.{" "}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
          </Alert>
        </div>
      </React.Fragment >
    )
  }
}

GroupReport.propTypes = {
  groupReport: PropTypes.func,
  onGetCaptcha: PropTypes.func,
  placesAPIToken: PropTypes.func,
  groupReport: PropTypes.func,
  groupFetchReport: PropTypes.func,
  history: PropTypes.any,
  groupReportError: PropTypes.any,
}

const mapStateToProps = ({ projects, Login, groupReport }) => ({
  placesToken: projects.placesToken,
  captchaOject: Login.captchaOject,
  groupMaster: groupReport.group,
  loading: groupReport.loading,
  groupReportError: groupReport.groupReportError,
  token: groupReport.token,



})

const mapDispatchToProps = dispatch => ({
  placesAPIToken: () => dispatch(getPlacesAPIToken()),
  onGetCaptcha: () => dispatch(onGetCaptcha()),
  groupReport: (values, history) => dispatch(groupReport(values, history)),
  groupFetchReport: (token) => dispatch(groupFetchReport(token)),

})

export default connect(mapStateToProps, mapDispatchToProps)(GroupReport)

